import { render, staticRenderFns } from "./educationCurriculumInfo.vue?vue&type=template&id=8750860c"
import script from "./educationCurriculumInfo.vue?vue&type=script&lang=js"
export * from "./educationCurriculumInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8750860c')) {
      api.createRecord('8750860c', component.options)
    } else {
      api.reload('8750860c', component.options)
    }
    module.hot.accept("./educationCurriculumInfo.vue?vue&type=template&id=8750860c", function () {
      api.rerender('8750860c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/cc/educationCurriculumInfo.vue"
export default component.exports